import {ActivitiesGroup} from '../../../../../backend/interfaces/activities-group';
import {Environment} from '../../../../../enums/environment';
import {
  CLINICAL_SUPPORT__EXAMS_ID,
  CLINICAL_SUPPORT__HEALTH_APPOINTMENTS_ID,
  CLINICAL_SUPPORT__MEDICATION_ID,
  CLINICAL_SUPPORT__NURSING_ID,
  CLINICAL_SUPPORT__OTHER_ID,
  CLINICAL_SUPPORT__PHYSIOTHERAPY_ID,
  CLINICAL_SUPPORT__SURGERY_ID,
  CLINICAL_SUPPORT__VACCINATION_ID,
  CLINICAL_SUPPORT__VITAL_SIGNS_ID,
  BADL__BATH_ID,
  BADL__CLOTHING_ID,
  BADL__ELIMINATION_ID,
  BADL__FOOD_ID,
  BADL__OTHER_ID,
  BADL__PERSONAL_HYGIENE_ID,
  BADL__POSITION_MOBILITY_ID,
  BADL__SLEEP_ID,
  IADL__ESCORT_ID,
  IADL__HOUSEKEEPING_ID,
  IADL__LAUNDRY_ID,
  IADL__OTHER_ID,
  IADL__SHOPPING_ID,
  IADL__TRANSPORT_ID,
  PERSONAL_DEVELOPMENT__COGNITIVE_INTELLECTUAL_ID,
  PERSONAL_DEVELOPMENT__OTHER_ID,
  PERSONAL_DEVELOPMENT__PHYSICS_MOVEMENT_ID,
  PERSONAL_DEVELOPMENT__RECREATIONAL_ARTISTIC_ID,
  PERSONAL_DEVELOPMENT__RELIGION_SPIRITUALITY_ID,
  PERSONAL_DEVELOPMENT__DAILY_OCCUPATION_ID,
  PERSONAL_DEVELOPMENT__SENSORY_ID,
  PERSONAL_DEVELOPMENT__SOCIOCULTURAL_ID,
  PERSONAL_DEVELOPMENT__SOCIAL_INTERACTION_ID,
} from '../../../../constants/hardcoded';

let logged: {[key: string]: boolean} = {};

export function exportCarePlanIsReady(
  activitiesGroup?: ActivitiesGroup | null,
  environment?: Environment
): boolean {
  if (!activitiesGroup) return false;

  const isReady =
    activitiesGroup.id === BADL__FOOD_ID ||
    activitiesGroup.id === BADL__CLOTHING_ID ||
    activitiesGroup.id === BADL__PERSONAL_HYGIENE_ID ||
    activitiesGroup.id === BADL__BATH_ID ||
    activitiesGroup.id === BADL__SLEEP_ID ||
    activitiesGroup.id === BADL__POSITION_MOBILITY_ID ||
    activitiesGroup.id === BADL__ELIMINATION_ID ||
    activitiesGroup.id === BADL__OTHER_ID ||
    activitiesGroup.id === IADL__TRANSPORT_ID ||
    activitiesGroup.id === IADL__LAUNDRY_ID ||
    activitiesGroup.id === IADL__HOUSEKEEPING_ID ||
    activitiesGroup.id === IADL__ESCORT_ID ||
    activitiesGroup.id === IADL__SHOPPING_ID ||
    activitiesGroup.id === IADL__OTHER_ID ||
    activitiesGroup?.id === CLINICAL_SUPPORT__MEDICATION_ID ||
    activitiesGroup?.id === CLINICAL_SUPPORT__VITAL_SIGNS_ID ||
    activitiesGroup.id === CLINICAL_SUPPORT__HEALTH_APPOINTMENTS_ID ||
    activitiesGroup.id === CLINICAL_SUPPORT__NURSING_ID ||
    activitiesGroup.id === CLINICAL_SUPPORT__VACCINATION_ID ||
    activitiesGroup.id === CLINICAL_SUPPORT__EXAMS_ID ||
    activitiesGroup.id === CLINICAL_SUPPORT__PHYSIOTHERAPY_ID ||
    activitiesGroup.id === CLINICAL_SUPPORT__SURGERY_ID ||
    activitiesGroup.id === CLINICAL_SUPPORT__OTHER_ID ||
    activitiesGroup.id === PERSONAL_DEVELOPMENT__COGNITIVE_INTELLECTUAL_ID ||
    activitiesGroup.id === PERSONAL_DEVELOPMENT__OTHER_ID ||
    activitiesGroup.id === PERSONAL_DEVELOPMENT__PHYSICS_MOVEMENT_ID ||
    activitiesGroup.id === PERSONAL_DEVELOPMENT__RECREATIONAL_ARTISTIC_ID ||
    activitiesGroup.id === PERSONAL_DEVELOPMENT__SOCIAL_INTERACTION_ID ||
    activitiesGroup.id === PERSONAL_DEVELOPMENT__RELIGION_SPIRITUALITY_ID ||
    activitiesGroup.id === PERSONAL_DEVELOPMENT__SOCIOCULTURAL_ID ||
    activitiesGroup.id === PERSONAL_DEVELOPMENT__DAILY_OCCUPATION_ID ||
    activitiesGroup.id === PERSONAL_DEVELOPMENT__SENSORY_ID;
  // || environment === Environment.Development;

  if (environment === Environment.Development && !logged[activitiesGroup.id]) {
    console.log(activitiesGroup?.name, 'is ready for export?:', isReady);
    logged[activitiesGroup.id] = true;
  }

  return isReady;
}
